import React from 'react';
import { VStack } from '@chakra-ui/react';
import { PaymentMethodRadioGroup, SelectedPaymentMethod } from './PaymentMethod';
import { MobilePayContactInfo } from '@olo-web/components/molecules/MobilePayContactInfo/MobilePayContactInfo.ui';
import { CardDetailsView } from '../../CardDetailsView';
import { useScreenSizeState } from '@olo-web/client-state';
import { usePaymentMethods } from '@olo-web/components/templates/Checkout/common/hooks/usePaymentMethods';
import { EPaymentMethods } from '@olo-web/types/enums/paymentMethods.enum';
import { usePaymentMethodValues } from '@olo-web/domain/payments/hooks';

export const CheckoutPaymentMethod = ({
  showEmailField,
  showSignInButton = true,
}: {
  showEmailField: boolean;
  showSignInButton?: boolean;
}) => {
  const { isCreditCard, isGooglePay, isApplePay } = usePaymentMethodValues();
  const { paymentMethods } = usePaymentMethods();
  const { isMdDown } = useScreenSizeState();

  const showCreditCardForm =
    isCreditCard && paymentMethods.some((method) => method.value === EPaymentMethods.CREDIT_CARD);

  return (
    <>
      <VStack w="100%" alignItems="stretch" spacing={6}>
        {isMdDown ? <SelectedPaymentMethod /> : <PaymentMethodRadioGroup />}
        {showCreditCardForm && (
          <CardDetailsView showEmailField={showEmailField} showSignInButton={showSignInButton} />
        )}
        {(isGooglePay || isApplePay) && <MobilePayContactInfo />}
      </VStack>
    </>
  );
};
